export const parseLinkToRelative = (link: string) => {
  return link.startsWith('http') ? link.replace(/^.*\/\/[^\\/]+/, '') : link
}
